import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  // Estilos para el título con icono de info
  titleContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '4px',
    marginBottom: '16px',
  },

  titleText: {
    fontSize: '16px',
    lineHeight: '22px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 300,
    flex: 1,
  },

  infoButton: {
    padding: 0,
    marginTop: '0px',
  },

  infoIcon: {
    fontSize: '20px',
    color: 'rgba(0, 0, 0, 0.6)',
  },

  // Estilos para TextField (CUPS y dirección)
  textField: {
    marginBottom: '16px',
    '& .MuiFilledInput-root': {
      backgroundColor: '#fff',
      border: '1px solid rgba(217, 209, 197, 1)',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      paddingTop: 0,
      paddingBottom: 0,
      '&:before, &:after': {
        display: 'none',
      },
      '&:hover': {
        borderColor: '#004571',
      },
      '&.Mui-focused': {
        borderColor: '#004571',
      },
    },
    '& .MuiFilledInput-input': {
      fontSize: '14px',
      padding: '27px 12px 10px',
      lineHeight: '20px',
      '&::placeholder': {
        color: 'rgba(0, 0, 0, 0.38)',
        opacity: 1,
      },
    },
    '& .MuiFormHelperText-root': {
      fontSize: '14px',
    },
  },

  textFieldError: {
    marginBottom: '16px',
    '& .MuiFilledInput-root': {
      backgroundColor: '#fff',
      border: '1px solid #D3222A',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      paddingTop: 0,
      paddingBottom: 0,
      '&:before, &:after': {
        display: 'none',
      },
      '&:hover': {
        borderColor: '#D3222A',
      },
      '&.Mui-focused': {
        borderColor: '#D3222A',
      },
    },
    '& .MuiFilledInput-input': {
      fontSize: '14px',
      lineHeight: '20px',
      '&::placeholder': {
        color: 'rgba(0, 0, 0, 0.38)',
        opacity: 1,
      },
    },
    '& .MuiFormHelperText-root': {
      fontSize: '14px',
    },
  },

  // Estilos para TextField de dirección (con altura mayor)
  addressTextField: {
    maxWidth: '600px',
    '& .MuiFilledInput-root': {
      backgroundColor: '#fff',
      border: '1px solid rgba(217, 209, 197, 1)',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      paddingBottom: 0,
      minHeight: '56px',
      '&:before, &:after': {
        display: 'none',
      },
      '&:hover': {
        borderColor: '#004571',
      },
      '&.Mui-focused': {
        borderColor: '#004571',
      },
    },
    '& .MuiFilledInput-input': {
      fontSize: '14px',
      padding: '18px 12px',
      lineHeight: '20px',
      '&::placeholder': {
        color: 'rgba(0, 0, 0, 0.38)',
        opacity: 1,
      },
    },
    '& .MuiFormHelperText-root': {
      fontSize: '14px',
    },
  },

  addressTextFieldError: {
    maxWidth: '600px',
    '& .MuiFilledInput-root': {
      backgroundColor: '#fff',
      border: '1px solid #D3222A',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      paddingTop: 0,
      paddingBottom: 0,
      minHeight: '56px',
      '&:before, &:after': {
        display: 'none',
      },
      '&:hover': {
        borderColor: '#D3222A',
      },
      '&.Mui-focused': {
        borderColor: '#D3222A',
      },
    },
    '& .MuiFilledInput-input': {
      fontSize: '14px',
      padding: '18px 12px',
      lineHeight: '20px',
      '&::placeholder': {
        color: 'rgba(0, 0, 0, 0.38)',
        opacity: 1,
      },
    },
    '& .MuiFormHelperText-root': {
      fontSize: '14px',
    },
  },

  // Estilos para el toggle de modo
  toggleText: {
    fontSize: '16px',
    lineHeight: '20px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 300,
    marginBottom: '20px',
  },

  toggleLink: {
    color: 'rgba(0, 69, 113, 1)',
    textDecoration: 'underline',
    cursor: 'pointer !important',
    fontSize: '16px',
    fontWeight: 300,
    background: 'none',
    border: 'none',
    padding: 0,
    '&:hover': {
      cursor: 'pointer !important',
    },
  },

  // Estilos para el botón principal
  submitButton: {
    backgroundColor: '#E57200',
    color: '#fff',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 600,
    borderRadius: '100px',
    padding: '12px 32px',
    minWidth: '140px',
    textTransform: 'capitalize',
    border: 'none',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#DC6016',
      boxShadow: 'none',
    },
    '&:disabled': {
      backgroundColor: '#DC6016',
      opacity: 0.5,
      color: '#fff',
    },
  },

  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: '24px',
  },

  // Estilos para títulos de sección
  sectionTitle: {
    fontSize: '16px',
    lineHeight: '22px',
    color: '#023C64',
    fontWeight: 400,
    marginBottom: '8px',
  },

  sectionSubtitle: {
    fontSize: '16px',
    lineHeight: '22px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 300,
    marginBottom: '16px',
  },

  // Estilos para Autocomplete
  autocompleteContainer: {
    marginBottom: '16px',
  },

  autocompleteVerticals: {
    marginBottom: '16px',
    maxWidth: '600px',
  },

  // Contenedor para dirección + número en línea
  addressInputRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    alignItems: 'flex-start',
    marginBottom: '16px',
  },

  // Autocomplete cuando está con campo de número
  addressAutocompleteWithNumber: {
    flex: 1,
    minWidth: 0,
  },

  // Estilos para opciones del Autocomplete
  optionContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minHeight: '40px',
    padding: '8px 12px',
  },

  optionIcon: {
    fontSize: '16px',
    color: '#004571',
  },

  optionText: {
    fontSize: '14px',
  },

  optionTextBold: {
    fontWeight: 700,
  },

  // Estilos para el helper de CUPS
  helperContainer: {
    marginTop: '16px',
    marginBottom: '16px',
  },

  helperTextField: {
    maxWidth: '600px',
    marginBottom: '16px',
    '& .MuiFilledInput-root': {
      backgroundColor: '#fff',
      border: '1px solid rgba(217, 209, 197, 1)',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      paddingTop: 0,
      paddingBottom: 0,
      minHeight: '56px',
      '&:before, &:after': {
        display: 'none',
      },
      '&:hover': {
        borderColor: '#004571',
      },
      '&.Mui-focused': {
        borderColor: '#004571',
      },
    },
    '& .MuiFilledInput-input': {
      fontSize: '14px',
      lineHeight: '20px',
      '&::placeholder': {
        color: 'rgba(0, 0, 0, 0.38)',
        opacity: 1,
      },
    },
  },

  helperAlert: {
    maxWidth: '600px',
    alignItems: 'center',
    '& .MuiAlert-message': {
      padding: '8px 0',
    },
  },

  helperAlertIcon: {
    fontSize: '24px',
  },

  helperAlertText: {
    fontSize: '16px',
    lineHeight: '24px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 400,
  },

  alertLink: {
    color: 'rgba(0, 69, 113, 1) !important',
    textDecoration: 'underline !important',
    cursor: 'pointer !important',
    fontWeight: '400 !important',
    '&:hover': {
      cursor: 'pointer !important',
    },
  },

  fontWeight: {
    fontWeight: 400,
  },

  textDecoration: {
    textDecoration: 'underline',
  },

  cursor: {
    cursor: 'pointer !important',
  },

  // Estilos para el campo de número
  numberTextField: {
    width: '110px',
    minWidth: '110px',
    flexShrink: 0,
    '& .MuiFilledInput-root': {
      backgroundColor: '#fff',
      border: '1px solid rgba(217, 209, 197, 1)',
      borderRadius: '4px',
      minHeight: '56px',
      paddingTop: '0px !important',
      paddingBottom: '0px !important',
      display: 'flex',
      alignItems: 'center',
      '&:before, &:after': {
        display: 'none',
      },
      '&:hover': {
        borderColor: '#004571',
      },
      '&.Mui-focused': {
        borderColor: '#004571',
      },
    },
    '& .MuiFilledInput-input': {
      fontSize: '14px',
      padding: '20px 12px 6px 12px !important',
      lineHeight: '20px',
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(0, 0, 0, 0.45)',
      fontSize: '14px',
      transform: 'translate(12px, 18px) scale(1)',
      transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
      pointerEvents: 'none',
      '&.Mui-focused': {
        color: 'rgba(0, 0, 0, 0.45)',
        transform: 'translate(12px, 8px) scale(0.75)',
      },
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(12px, 8px) scale(0.75)',
    },
  },
}));

export default useStyles;
